import dayjs from 'dayjs';

export const formatDate = (date, formatPattern = 'MMMM DD, YYYY') => {
  if (!date) return '';
  return dayjs(date).format(formatPattern);
};
